var e=n=>Object.assign(n,{single:!0});export{e as a};
